export default __webpack_public_path__ + "static/media/t1tan.1c04efcd.png";